exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.dataContainer[data-v-7cd52d0e]{              \n    text-align: center;\n}\n.carPhotosList div[data-v-7cd52d0e] {\n    float: left;       \n    margin: 5px;\n}\n.glyphiconSize[data-v-7cd52d0e]{\n    font-size: 3em;\n}\n@media screen and (max-width: 981px) {\n.glyphiconSize[data-v-7cd52d0e]{\n         font-size: 8em;\n}\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-7cd52d0e","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/misc/Gallery.vue
// module id = 90
// module chunks = 0